import {Component, Input, OnChanges} from '@angular/core';
import {HighchartsChartModule} from 'highcharts-angular';
import {NoWidgetDataComponent} from '../../../../components/my-brand-screen/no-widget-data/no-widget-data.component';
import {RefreshRateDistributionResponse} from '../../../../components/my-campaigns-screen/types';
import Highcharts, {Chart, SeriesOptionsType} from 'highcharts';
import {NgIf} from '@angular/common';
import {LoaderComponent} from '../../loader/loader.component';

@Component({
  selector: 'app-refresh-rate-distribution',
  imports: [
    NgIf,
    HighchartsChartModule,
    NoWidgetDataComponent,
    LoaderComponent
  ],
  templateUrl: './refresh-rate-distribution.component.html',
  styleUrl: './refresh-rate-distribution.component.scss'
})
export class RefreshRateDistributionComponent implements OnChanges {

  @Input() data?: RefreshRateDistributionResponse;
  @Input() loading: boolean = false;

  protected readonly Highcharts: typeof Highcharts = Highcharts;
  protected chartOptions?: Highcharts.Options;
  private _chartInstance?: Chart;

  ngOnChanges(): void {
    if (this.data) {
      this.chartOptions = {
        chart: {
          type: 'column',
          height:584,
          spacingLeft: 0
        },
        title: {
          text: undefined,
        },
        xAxis: {
          categories: this.data.sites.map(({domain}) => domain),
          title: {
            text: null
          },
          labels: {
            useHTML: true,
            formatter: function () {
              return `<span title="${this.value}">${this.value}</span>`;
            },
            style: {
              fontFamily: 'Poppins',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '18px',
              maxWidth: '150px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineClamp: 1,
              color: '#4E5258',
            },
            overflow: 'allow',
            rotation: -50
          }
        },
        yAxis: {
          min: 0,
          max: 100,
          tickInterval: 10,
          title: {
            text: null
          },
          labels: {
            format: '{value}%',
            style:{
                color: '#686D75',
                fontSize: '12px',
                fontFamily: 'Poppins',
                fontWeight: '400',
                lineHeight: '18px',
                fontStyle: 'normal',
            }
          }
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          title: {
            text: undefined
          },
          itemStyle:{
            color: '#686D75',
          },
          align: 'left',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          floating: false,
          reversed: true,
          symbolRadius: 6,
          events:{
            itemClick: () => false,
          },
          itemHoverStyle:{
            cursor: 'default'
          }

        },
        credits:{
          enabled: false,
        },
        plotOptions: {
          series: {
            stacking: 'percent',
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return this.y !== 0 ? this.y + '%' : null;
              },
              style: {
                fontFamily: 'Poppins',
                fontWeight: '400',
                color: '#34363A',
                textOutline: 'none',
                fontSize: '14px',
              },
              verticalAlign: 'middle',
              align: 'center',
            },
            animation: false,
          },
        },
        series: this.distributionResponseToChartData(this.data)

      }
    }
  }

  set chartInstance(instance: Highcharts.Chart | undefined) {
    if (instance) {
      this._chartInstance = instance;
    }
  }

  private distributionResponseToChartData(data: RefreshRateDistributionResponse): SeriesOptionsType[] {
    return [
      {
        type: 'column',
        name: 'No Refresh',
        color: '#ABD6D4',
        data: data.sites.map(site => site.refreshRateBuckets['NONE']),
        pointWidth: 72,
        pointStart: 0
      },
      {
        type: 'column',
        color: '#97B1C7',
        name: '30+ seconds',
        data: data.sites.map(site => site.refreshRateBuckets['30_']),
        pointWidth: 72,
        pointStart: 0,

      },
      {
        type: 'column',
        name: '21-30 seconds',
        color: '#FFCC66',
        data: data.sites.map(site => site.refreshRateBuckets['21_30']),
        pointWidth: 72,
        pointStart: 0,
      },

      {
        type: 'column',
        name: '11-20 seconds',
        color: '#F1B498',
        data: data.sites.map(site => site.refreshRateBuckets['11_20']),
        pointWidth: 72,
        pointStart: 0,
      },
      {
        type: 'column',
        name: '10 sec or less',
        color: '#FF8039',
        data: data.sites.map(site => site.refreshRateBuckets['_10']),
        pointWidth: 72,
        pointStart: 0,

      },
    ]
  }
}
